import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  // Function to read Excel as an array of objects
  readExcelFile(file: File): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        const data: string = e.target.result;
        const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'binary' });

        // Get the first sheet from the workbook
        const firstSheet: XLSX.WorkSheet = workbook.Sheets[workbook.SheetNames[0]];
        
        // Convert the sheet to JSON
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

        // Define mapping of the columns
        const formattedData = jsonData.slice(1).map((row: any) => {
          return {
            customer_po_number: row[0], // '2025 - Contract Legal Stratus Number'
            rcdss_contract_program: row[2], // 'PROGRAM'
            supplier_name: row[1]  // 'SERVICE PROVIDER'
          };
        });

        // Filter rows where all 3 fields are non-empty
        const filteredData = formattedData.filter(row => 
          row.customer_po_number && row.rcdss_contract_program && row.supplier_name
        );
        
        resolve(filteredData);  // Return filtered data
      };

      reader.onerror = error => reject(error);
      reader.readAsBinaryString(file);
    });
  }
}